import { useContainer } from 'unstated-next';

import { Box } from '@mui/material';
import SendInvites, { SendInvitesProps } from './components/SendInvites';
import InviteStudentsContainer from './InviteStudentsContainer';
import AdvancedInvite from './InviteStudentsPanels/AdvancedInvite';
import InviteErrors from './InviteStudentsPanels/InviteErrors';
import SimpleInvite from './InviteStudentsPanels/SimpleInvite';
import UploadInvite from './InviteStudentsPanels/UploadInvite';
import { StyledAlert } from './styles/styled-components';
import { InviteTabs } from './types/inviteStudentsTypes';
import { MsTeamsInvite } from './InviteStudentsPanels/MsTeamsInvite';

export type InviteStudentsBodyProps = SendInvitesProps & {};

const InviteStudentsBody = (props: InviteStudentsBodyProps) => {
    const { alerts, setAlerts, activeTab } = useContainer(InviteStudentsContainer);

    return (
        <Box mx={2}>
            {alerts.map((alert, index) => {
                const message = typeof alert.message === 'function' ? alert.message() : alert.message;

                return (
                    <StyledAlert
                        sx={{ my: 4 }}
                        key={index}
                        variant="outlined"
                        severity={alert.severity}
                        onClose={() => {
                            setAlerts(alerts.filter((value, i) => i !== index));
                        }}
                    >
                        {message}
                    </StyledAlert>
                );
            })}

            {activeTab === InviteTabs.SIMPLE && <SimpleInvite />}
            {activeTab === InviteTabs.ADVANCED && <AdvancedInvite />}
            {activeTab === InviteTabs.BULK_IMPORT && <UploadInvite />}
            {activeTab === InviteTabs.MS_TEAMS && <MsTeamsInvite />}
            {activeTab === InviteTabs.ERROR && <InviteErrors />}

            <SendInvites {...props} />
        </Box>
    );
};

export default InviteStudentsBody;
